import ajax from "./ajax";

// 前
export const list = params => ajax(`/product/list`, params,'POST');


// 后
export const listByPage = params => ajax(`/product/listByPage`, params,'POST');
export const insert = params => ajax(`/product/insert`, params,'POST');
export const update = params => ajax(`/product/update`, params,'POST');
export const del = params => ajax(`/product/deleteMutil`, params,'POST');
export const querySingle = params => ajax(`/product/querySingle`, params,'POST');


export const listByPagePro = params => ajax(`/brightPoints/listByPage`, params,'POST');
export const insertPro = params => ajax(`/brightPoints/insert`, params,'POST');
export const updatePro = params => ajax(`/brightPoints/update`, params,'POST');
export const deleteMutil = params => ajax(`/brightPoints/deleteMutil`, params,'POST');
export const querySinglePro = params => ajax(`/brightPoints/querySingle`, params,'POST');


